<div class="my-profile">
  <div class="profile-container">
    <header class="profile-header">
      <div>
        <h1 class="profile-name">{{ displayName }}</h1>
        <div class="profile-email">{{ displayEmail }}</div>
      </div>
    </header>

    <div *ngIf="loading" class="profile-loading">Loading…</div>

    <div *ngIf="!loading && notFound" class="profile-empty">
      <h3>No collector profile</h3>
      <p>
        Your account isn't registered as a collector yet. Ask an admin to add
        you to the collectors list, then refresh this page.
      </p>
    </div>

    <div *ngIf="!loading && errorMessage" class="profile-error">
      {{ errorMessage }}
    </div>

    <mat-tab-group
      *ngIf="hasProfile"
      class="profile-tabs"
      [selectedIndex]="selectedTabIndex"
    >
      <mat-tab label="Profile">
        <div *ngIf="config; else profileUnavailable" class="profile-grid">
          <div class="grid-identity">
            <app-collector-identity-card
              [collector]="collector!"
              [showProfileFields]="true"
            ></app-collector-identity-card>
          </div>
          <div class="grid-metrics">
            <app-collector-metrics-card
              [collector]="collector!"
              [readOnly]="true"
            ></app-collector-metrics-card>
          </div>
          <div class="grid-assessment">
            <app-collector-assessment-card
              [collector]="collector!"
              [config]="config!"
              [readOnly]="true"
            ></app-collector-assessment-card>
          </div>
          <div class="grid-skills">
            <app-collector-event-skills-card
              [collector]="collector!"
              [config]="config!"
              [readOnly]="true"
            ></app-collector-event-skills-card>
          </div>
          <div class="grid-combinations">
            <app-collector-event-combinations-card
              [collector]="collector!"
              [config]="config!"
              [readOnly]="true"
            ></app-collector-event-combinations-card>
          </div>
        </div>
        <ng-template #profileUnavailable>
          <div class="tab-content">
            <div class="profile-error">
              Profile details are temporarily unavailable. Please try again
              later.
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Availability">
        <div class="tab-content">
          <app-collector-availability-planner></app-collector-availability-planner>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
